module.exports = __webpack_public_path__ + "img/object-remover-after.a968d0e7.webp";